import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import Description from './Description'
import ColumnsWrapper from './ColumnsWrapper'

import Bottom from './Bottom'

import * as Styles from './Footer.module.css'

// import PropTypes from 'prop-types'

const Footer = ({ description }) => {
  const data = useStaticQuery(query)

  return (
    <footer className={Styles.footer}>
      <div className={Styles.wrapper}>
        <Description description={description} />
        <ColumnsWrapper data={data} />
      </div>

      <Bottom />
    </footer>
  )
}

export const query = graphql`
  {
    footer: wpMenu(name: { eq: "Footer" }) {
      menuItems {
        nodes {
          id
          title: label
          slug: url
        }
      }
    }
    integrations: allWpIntegration {
      nodes {
        id
        title
        slug
      }
    }
    support: wpMenu(name: { eq: "Support" }) {
      menuItems {
        nodes {
          id
          title: label
          slug: url
        }
      }
    }
    allWpPost(limit: 3) {
      nodes {
        id
        title
        slug
        featuredImage {
          node {
            localFile {
              childImageSharp {
                id
                fluid(quality: 70, maxWidth: 240, maxHeight: 240) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`

// Footer.propTypes = {}

export default Footer
